import axios from 'axios'

const api = axios.create({
    
// baseURL: 'http://43.228.126.245:4013',
//baseURL: 'http://66.29.149.122:2061',
baseURL: 'https://ecasadmin.unitdtechnologies.com:3008',
// baseURL: 'http://localhost:3001',


});

export default api